import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import logo from "static/images/logo.png";
import { clearRedirect } from "actions/user";

const WindowRedirect = (props) => {
  const { returnUrl, history } = props;
  useEffect(() => {
    if (returnUrl) {
      if (returnUrl.includes("://")) {
        window.location = returnUrl;
      } else {
        history.push(returnUrl);
      }
      props.clearRedirect();
    } else {
      history.push("../");
    }
  }, []);

  return (
    <>
      <div className="md-grid md-cell login-wrapper">
        <div className="login-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <h3 className="mueller-title" data-test="title" title="Connecting to destination">Connecting</h3>
          <MSpinner />
        </div>
      </div>
    </>);
};

WindowRedirect.propTypes = {
  returnUrl: PropTypes.string,
  token: PropTypes.string,
  history: PropTypes.object,
  clearRedirect: PropTypes.func,
};

const mstp = state => {
  return {
    returnUrl: (state.user.redirect && state.user.redirect.returnUrl) || (state.twoFactor.authResult && state.twoFactor.authResult.returnUrl),
    token: state.user.profile.token,
    clearRedirect: state.user.profile.clearRedirect,
  };
};

const mdtp = dispatch => ({
  clearRedirect() {
    dispatch(clearRedirect());
  }
});

export default connect(mstp, mdtp)(WindowRedirect);
